import React from 'react'
import Team from './teams'
import '../CSS/style.css'
import '../CSS/responsive.css'

function About(props) {
  // document.title = "About - UnlockCode"
  return (
    <>
      
        <div className="container fd-col m-auto">
        <h1 className="p-heading">About</h1>
          <p className='text-center'>Welcome to <strong>UnlockCode</strong>, your ultimate destination for programming solutions in all languages. At <strong>UnlockCode</strong>, we are committed to providing high-quality programming solutions and code snippets that can help you solve any coding problem, no matter how complex.

          Our team of expert programmers and developers have years of experience in the field of computer science, and they are passionate about sharing their knowledge with the community. Our goal is to make programming accessible to everyone, regardless of their level of expertise.

          On our website, you will find a vast collection of programming solutions in all languages. From <strong>Python</strong> to <strong>Java</strong>, from <strong>C++</strong> to <strong>C</strong>, we cover all the major programming languages used today. Our solutions are carefully crafted to be easy to understand and follow, so even if you are new to programming, you can benefit from our code snippets and tutorials.

          At <strong>UnlockCode</strong>, we believe in the power of collaboration and community. That's why we encourage our users to contribute to our website by submitting their own code snippets and solutions. By working together, we can create a rich and diverse programming resource that can benefit everyone.

          In addition to programming solutions, we also offer tutorials, tips, and tricks to help you improve your programming skills. Whether you are a beginner or an experienced programmer, you can benefit from our resources and take your coding skills to the next level.

          We are committed to providing a user-friendly and intuitive platform that makes it easy for you to find the solutions you need. Our website is constantly updated with new content, so be sure to check back often for the latest programming solutions and resources.

          Thank you for choosing UnlockCode as your go-to resource for programming solutions. We look forward to helping you unlock your coding potential!</p>
        </div>
     <Team />
    </>
  )
}

export default About